import { SelectOption } from "@models/ui-models/select-options";

export const postponeMenu: SelectOption<number>[] = [
  { label: 'One day', value: 1 },
  { label: 'One week', value: 7 },
  { label: 'Two weeks', value: 14 },
  { label: 'One month', value: 30 }
];
